import { apiClient } from '@/lib/apiClient';

export interface BookingSlot {
  startUtc: string;
  endUtc: string;
  seatId: string;
  doctorId: string;
  doctorName: string;
}
export interface BookingCandidate { patientId: string; name: string; }
export interface ActionAppointment {
  appointmentId: string;
  startUtc: string;
  endUtc: string;
  doctorName: string;
  cabinetName: string;
}

export type BookingIntent = 'book' | 'reschedule' | 'cancel' | 'none';
export type BookingStatus =
  | 'not_booking' | 'no_patient' | 'ambiguous' | 'no_appointment' | 'no_cabinet' | 'no_slots' | 'propose' | 'confirm_cancel';

export interface BookingResolution {
  intent: BookingIntent;
  status: BookingStatus;
  cabinetId: string | null;
  cabinetName: string | null;
  slotMinutes: number;
  patientId: string | null;
  patientName: string | null;
  candidates: BookingCandidate[];
  slots: BookingSlot[];
  appointments: ActionAppointment[];
  rescheduleAppointmentId: string | null;
  whenLabel: string | null;
}

/** Local (no-LLM) booking resolver: turns a command into a slot proposal or a disambiguation. */
export const resolveBooking = async (command: string, cabinetId?: string, patientId?: string) =>
  (await apiClient.post<BookingResolution>('/ai/booking/resolve', {
    command,
    cabinetId: cabinetId ?? null,
    patientId: patientId ?? null,
  })).data;
